function initProductConfigurator() {
  const variantsDataEl = document.getElementById('configurator-variants-data');
  const optionsDataEl = document.getElementById('configurator-options-data');

  if (!variantsDataEl || !optionsDataEl) return;

  const variants = JSON.parse(variantsDataEl.textContent);
  const config = JSON.parse(optionsDataEl.textContent);
  console.log("[CONFIGURATOR DEBUG] All variants parsed:", variants);
  console.log("[CONFIGURATOR DEBUG] Config:", config);

  // Inject toast notification styles dynamically
  if (!document.getElementById('sds-cart-notification-styles')) {
    const style = document.createElement('style');
    style.id = 'sds-cart-notification-styles';
    style.textContent = `
      .sds-cart-toast {
        position: fixed;
        bottom: 24px;
        right: 24px;
        background: #0a0a0c;
        border: 1px solid #1f1f22;
        border-left: 4px solid #c0f20c;
        color: #fff;
        padding: 16px 20px;
        border-radius: 8px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.5);
        z-index: 10000;
        display: flex;
        align-items: center;
        gap: 16px;
        transform: translateY(150%);
        transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        max-width: 400px;
        font-family: inherit;
      }
      .sds-cart-toast.active {
        transform: translateY(0);
      }
      .sds-toast-content {
        display: flex;
        flex-direction: column;
        gap: 4px;
        text-align: left;
      }
      .sds-toast-title {
        font-family: 'Sakana-Regular', sans-serif !important;
        font-style: italic !important;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #c0f20c;
      }
      .sds-toast-desc {
        font-size: 12px;
        color: #a3a3a3;
      }
      .sds-toast-actions {
        display: flex;
        gap: 10px;
        margin-top: 8px;
      }
      .sds-toast-btn {
        background: #c0f20c;
        color: #000;
        border: none;
        padding: 6px 12px;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        border-radius: 4px;
        cursor: pointer;
        text-decoration: none;
        display: inline-block;
      }
      .sds-toast-btn-secondary {
        background: transparent;
        color: #fff;
        border: 1px solid #1f1f22;
      }
      .sds-toast-close {
        color: #737373;
        background: transparent;
        border: none;
        font-size: 16px;
        cursor: pointer;
        align-self: flex-start;
      }
    `;
    document.head.appendChild(style);
  }

  function showCartNotification(title, message) {
    const existing = document.querySelector('.sds-cart-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'sds-cart-toast';
    toast.innerHTML = `
      <div class="sds-toast-content">
        <span class="sds-toast-title">${title}</span>
        <span class="sds-toast-desc">${message}</span>
        <div class="sds-toast-actions">
          <a href="/cart" class="sds-toast-btn">View Cart</a>
          <button type="button" class="sds-toast-btn sds-toast-btn-secondary" onclick="this.closest('.sds-cart-toast').classList.remove('active')">Continue</button>
        </div>
      </div>
      <button type="button" class="sds-toast-close" onclick="this.closest('.sds-cart-toast').classList.remove('active')">&times;</button>
    `;
    document.body.appendChild(toast);
    
    setTimeout(() => toast.classList.add('active'), 100);

    setTimeout(() => {
      toast.classList.remove('active');
      setTimeout(() => toast.remove(), 400);
    }, 5000);
  }

  function updateHeaderCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartLink = document.getElementById('cart-icon-bubble');
        if (!cartLink) return;

        let bubble = cartLink.querySelector('.cart-count-bubble');
        if (cart.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            cartLink.appendChild(bubble);
          }
          bubble.innerHTML = `
            <span aria-hidden="true">${cart.item_count}</span>
            <span class="visually-hidden">Cart (${cart.item_count} items)</span>
          `;
        } else {
          if (bubble) bubble.remove();
        }
      })
      .catch(err => console.error('[CONFIGURATOR] Failed to update header cart count:', err));
  }

  // Helper to find available materials for a component
  function getAvailableMaterialsForComponent(componentName) {
    const compKey = 'option' + (config.componentIndex || 1);
    const matKey = 'option' + (config.materialIndex || 2);
    const list = [];
    variants.forEach(v => {
      const compVal = (v[compKey] || '').trim().toLowerCase();
      const target = (componentName || '').trim().toLowerCase();
      if (compVal === target && v[matKey]) {
        list.push(v[matKey]);
      }
    });
    return list;
  }

  // Helper to check if the product has detailed carbon finishes globally in any variant options
  function hasDetailedSubFinishesGlobal() {
    return variants.some(v => {
      const opt1 = (v.option1 || '').toLowerCase();
      const opt2 = (v.option2 || '').toLowerCase();
      const opt3 = (v.option3 || '').toLowerCase();
      return [opt1, opt2, opt3].some(val => 
        val.includes('matte') || val.includes('gloss') || val.includes('forged') || val.includes('kevlar')
      );
    });
  }

  // State
  const state = {
    completeKitChecked: document.querySelector('.complete-kit-card') !== null,
    completeKitMaterial: 'Matte Carbon', // Default complete kit material
    components: {} // Map of componentName -> { checked: bool, material: string }
  };

  const compCompleteKitCheckbox = document.getElementById('comp-complete-kit');

  // Initialize configurator states dynamically based on available variants
  document.querySelectorAll('.configurator-card').forEach(card => {
    const componentName = card.dataset.component;
    if (!componentName) return;

    const isKit = card.classList.contains('complete-kit-card');
    const checkbox = card.querySelector('.configurator-checkbox');
    const isChecked = checkbox ? checkbox.checked : true;

    // Find available materials from variants
    const availableMaterials = getAvailableMaterialsForComponent(componentName);

    // Determine availability of FRP and Carbon
    const hasFRP = availableMaterials.some(m => m.toLowerCase().includes('frp') || m.toLowerCase().includes('fiberglass'));
    const hasCarbon = availableMaterials.some(m => m.toLowerCase().includes('carbon') || m.toLowerCase().includes('kevlar'));

    // Show/hide pills based on catalog availability
    const frpPill = card.querySelector('.material-pill[data-material-group="FRP"]');
    const carbonPill = card.querySelector('.material-pill[data-material-group="CARBON"]');

    if (frpPill) {
      if (hasFRP) {
        frpPill.classList.remove('hidden');
      } else {
        frpPill.classList.add('hidden');
      }
    }

    if (carbonPill) {
      if (hasCarbon) {
        carbonPill.classList.remove('hidden');
      } else {
        carbonPill.classList.add('hidden');
      }
    }

    // Determine active group and active finish
    let activeGroup = 'FRP';
    let activeFinish = 'Fiberglass (FRP)';
    const hasDetailedCarbon = hasDetailedSubFinishesGlobal();

    if (hasFRP && !hasCarbon) {
      activeGroup = 'FRP';
      activeFinish = availableMaterials.find(m => m.toLowerCase().includes('frp') || m.toLowerCase().includes('fiberglass')) || 'Fiberglass (FRP)';
    } else if (!hasFRP && hasCarbon) {
      activeGroup = 'CARBON';
      if (hasDetailedCarbon) {
        activeFinish = availableMaterials.find(m => m.toLowerCase().includes('matte carbon')) ||
          availableMaterials.find(m => m.toLowerCase().includes('carbon') || m.toLowerCase().includes('kevlar')) ||
          'Matte Carbon';
      } else {
        activeFinish = availableMaterials.find(m => m.toLowerCase().includes('carbon') || m.toLowerCase().includes('kevlar')) || 'Carbon Fiber';
      }
    } else {
      const activePill = card.querySelector('.material-pill.active');
      activeGroup = activePill ? activePill.dataset.materialGroup : 'FRP';
      if (activeGroup === 'CARBON') {
        if (hasDetailedCarbon) {
          const activeSubBox = card.querySelector('.sub-finish-box.active');
          activeFinish = activeSubBox ? activeSubBox.dataset.finish : 'Matte Carbon';
        } else {
          activeFinish = availableMaterials.find(m => m.toLowerCase().includes('carbon') || m.toLowerCase().includes('kevlar')) || 'Carbon Fiber';
        }
      } else {
        activeFinish = availableMaterials.find(m => m.toLowerCase().includes('frp') || m.toLowerCase().includes('fiberglass')) || 'Fiberglass (FRP)';
      }
    }

    // Sync active classes in DOM for pills
    card.querySelectorAll('.material-pill').forEach(p => {
      if (p.dataset.materialGroup === activeGroup) {
        p.classList.add('active');
      } else {
        p.classList.remove('active');
      }
    });

    // Sync sub-finish boxes and group visibility
    const subFinishSelector = card.querySelector('.sub-finish-selector');
    if (subFinishSelector) {
      if (activeGroup === 'CARBON' && hasDetailedCarbon) {
        subFinishSelector.classList.remove('hidden');
        card.querySelectorAll('.sub-finish-box').forEach(box => {
          const finishVal = box.dataset.finish;
          const isFinishAvailable = availableMaterials.some(m => m.trim().toLowerCase() === finishVal.trim().toLowerCase());
          if (isFinishAvailable) {
            box.classList.remove('hidden');
          } else {
            box.classList.add('hidden');
          }

          if (finishVal.trim().toLowerCase() === activeFinish.trim().toLowerCase()) {
            box.classList.add('active');
          } else {
            box.classList.remove('active');
          }
        });
      } else {
        subFinishSelector.classList.add('hidden');
      }
    }

    // Save to state
    if (isKit) {
      state.completeKitMaterial = activeFinish;
      state.completeKitChecked = isChecked;
    } else {
      state.components[componentName] = {
        checked: isChecked,
        material: activeFinish
      };
    }
  });

  // Format price helper
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(cents / 100) + ' USD';
  }

  // Find variant helper
  function findVariant(component, material) {
    const compKey = 'option' + (config.componentIndex || 1);
    const matKey = 'option' + (config.materialIndex || 2);
    return variants.find(v => {
      const vComp = (v[compKey] || '').trim().toLowerCase();
      const vMat = (v[matKey] || '').trim().toLowerCase();
      const targetComp = (component || '').trim().toLowerCase();
      const targetMat = (material || '').trim().toLowerCase();
      return vComp === targetComp && vMat === targetMat;
    });
  }

  // Sync all individual components to match Complete Kit configuration
  function syncComponentsToKit() {
    const isKitFRP = state.completeKitMaterial.toLowerCase().includes('frp') || state.completeKitMaterial.toLowerCase().includes('fiberglass');

    for (const componentName of Object.keys(state.components)) {
      state.components[componentName].checked = true;

      const available = getAvailableMaterialsForComponent(componentName);
      const hasFRP = available.some(m => m.toLowerCase().includes('frp') || m.toLowerCase().includes('fiberglass'));
      const hasCarbon = available.some(m => m.toLowerCase().includes('carbon') || m.toLowerCase().includes('kevlar'));

      let targetMaterial = state.completeKitMaterial;
      if (isKitFRP) {
        if (!hasFRP && hasCarbon) {
          // Fallback to carbon finish
          targetMaterial = available.find(m => m.toLowerCase().includes('matte carbon')) ||
            available.find(m => m.toLowerCase().includes('carbon') || m.toLowerCase().includes('kevlar')) ||
            'Matte Carbon';
        } else {
          // Map to component's actual FRP option string format (e.g. "FRP" or "Fiberglass (FRP)")
          targetMaterial = available.find(m => m.toLowerCase().includes('frp') || m.toLowerCase().includes('fiberglass')) || state.completeKitMaterial;
        }
      } else {
        const kitMatLower = state.completeKitMaterial.toLowerCase();
        if (!hasCarbon && hasFRP) {
          // Fallback to FRP finish
          targetMaterial = available.find(m => m.toLowerCase().includes('frp') || m.toLowerCase().includes('fiberglass')) ||
            'Fiberglass (FRP)';
        } else {
          // Match the exact carbon sub-finish format from the component's options
          targetMaterial = available.find(m => m.trim().toLowerCase() === kitMatLower) ||
            available.find(m => m.toLowerCase().includes('carbon') || m.toLowerCase().includes('kevlar')) ||
            state.completeKitMaterial;
        }
      }

      state.components[componentName].material = targetMaterial;

      const card = document.querySelector(`.configurator-card[data-component="${componentName}"]`);
      if (card) {
        const checkbox = card.querySelector('.configurator-checkbox');
        if (checkbox) checkbox.checked = true;

        const isFRP = targetMaterial.toLowerCase().includes('frp') || targetMaterial.toLowerCase().includes('fiberglass');
        card.querySelectorAll('.material-pill').forEach(p => {
          const group = p.dataset.materialGroup;
          if ((isFRP && group === 'FRP') || (!isFRP && group === 'CARBON')) {
            p.classList.add('active');
          } else {
            p.classList.remove('active');
          }
        });

        const subFinishSelector = card.querySelector('.sub-finish-selector');
        if (subFinishSelector) {
          if (isFRP) {
            subFinishSelector.classList.add('hidden');
          } else {
            subFinishSelector.classList.remove('hidden');
            card.querySelectorAll('.sub-finish-box').forEach(box => {
              if (box.dataset.finish.trim().toLowerCase() === targetMaterial.trim().toLowerCase()) {
                box.classList.add('active');
              } else {
                box.classList.remove('active');
              }
            });
          }
        }
      }
    }
  }

  // Check and coordinate the active checkbox state of Complete Kit
  function checkCompleteKitStatus() {
    const entries = Object.entries(state.components);
    const allChecked = entries.every(([_, cState]) => cState.checked);

    if (allChecked) {
      const firstMaterial = entries[0][1].material;
      const allSameMaterial = entries.every(([_, cState]) => cState.material === firstMaterial);

      if (allSameMaterial) {
        state.completeKitChecked = true;
        state.completeKitMaterial = firstMaterial;
        if (compCompleteKitCheckbox) compCompleteKitCheckbox.checked = true;

        const kitCard = document.querySelector('.complete-kit-card');
        if (kitCard) {
          kitCard.querySelectorAll('.sub-finish-box').forEach(box => {
            if (box.dataset.finish.trim().toLowerCase() === firstMaterial.trim().toLowerCase()) {
              box.classList.add('active');
            } else {
              box.classList.remove('active');
            }
          });
        }
        return;
      }
    }

    state.completeKitChecked = false;
    if (compCompleteKitCheckbox) compCompleteKitCheckbox.checked = false;
  }

  // Render & Update UI
  function updateConfigurator() {
    const manifestList = document.getElementById('sds-specs-manifest-list');
    if (!manifestList) return;

    manifestList.innerHTML = '';

    const selections = [];
    let basePriceSum = 0;
    let finalPrice = 0;
    let discountAmount = 0;

    // Visually update component cards active state based on checkbox state
    document.querySelectorAll('.configurator-card.component-card').forEach(card => {
      const componentName = card.dataset.component;
      const compState = state.components[componentName];
      if (compState) {
        if (compState.checked) {
          card.classList.add('active');
        } else {
          card.classList.remove('active');
        }
      }
    });

    // Unconditionally update individual card prices and labels based on their current material state
    for (const [componentName, compState] of Object.entries(state.components)) {
      const card = document.querySelector(`.configurator-card[data-component="${componentName}"]`);
      const variant = findVariant(componentName, compState.material);

      if (variant && card) {
        const priceEl = card.querySelector('.card-price');
        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        const labelClassification = card.querySelector('.card-material-classification');
        const subLabel = card.querySelector('.card-price-sub');

        if (labelClassification && subLabel) {
          const matLower = (compState.material || '').trim().toLowerCase();
          if (matLower === 'fiberglass (frp)' || matLower === 'frp' || matLower === 'fiberglass') {
            labelClassification.textContent = config.textMaterialFrpLabel || 'STANDARD GELCOAT';
            subLabel.textContent = config.textFrpPriceSub || '-$180 GELCOAT';
          } else {
            labelClassification.textContent = config.textMaterialCarbonLabel || 'BESPOKE WEAVE';
            if (matLower === 'forged carbon' || matLower === 'forged') {
              subLabel.textContent = config.textForgedPriceSub || '+10% FORGED';
            } else if (matLower === 'kevlar') {
              subLabel.textContent = config.textKevlarPriceSub || '+12% KEVLAR';
            } else {
              subLabel.textContent = config.textCarbonPriceSubDefault || 'STAND-WEAVE';
            }
          }
        }
      }
    }

    const componentValues = Object.values(state.components);
    const isCompleteKit = componentValues.length >= 2 && componentValues.every(c => c.checked);
    const allSameMaterial = Object.values(state.components).length > 0 && Object.values(state.components).every(c => c.material === Object.values(state.components)[0].material);

    let retailSubtotal = 0;
    let checkedCount = 0;
    let totalCount = 0;

    // Calculate retail subtotal of selected parts
    for (const [componentName, compState] of Object.entries(state.components)) {
      totalCount++;
      const variant = findVariant(componentName, compState.material);
      if (compState.checked && variant) {
        checkedCount++;
        retailSubtotal += variant.price;
      }
    }

    let isScenarioA = false;
    let kitVariant = null;

    if (isCompleteKit && allSameMaterial) {
      const kitMaterial = Object.values(state.components)[0].material;
      kitVariant = findVariant(config.completeKitValue, kitMaterial);
      if (kitVariant) {
        isScenarioA = true;
      }
    }

    if (isScenarioA) {
      // Scenario A: Uniform Complete Kit (submits single variant ID)
      const kitMaterial = Object.values(state.components)[0].material;
      finalPrice = kitVariant.price;

      // Show complete kit in spec manifest
      const row = document.createElement('div');
      row.className = 'specs-manifest-row';
      row.innerHTML = `
        <span class="manifest-comp-name">${config.completeKitValue}</span>
        <div class="manifest-meta-group">
          <span class="manifest-material-tag">${kitMaterial}</span>
          <span class="manifest-price-tag">${formatMoney(kitVariant.price)}</span>
        </div>
      `;
      manifestList.appendChild(row);
      selections.push(kitVariant);

      // If the complete kit price is lower than sum of parts, show the difference as discount
      if (retailSubtotal > finalPrice) {
        discountAmount = retailSubtotal - finalPrice;
      } else {
        retailSubtotal = finalPrice;
      }

      document.getElementById('sds-selections-count').textContent = 'ALL COMPONENTS';

    } else {
      // Scenarios B & C: Mixed Complete Kit or Incomplete Kit (submits individual variants)
      for (const [componentName, compState] of Object.entries(state.components)) {
        const variant = findVariant(componentName, compState.material);

        if (compState.checked && variant) {
          const row = document.createElement('div');
          row.className = 'specs-manifest-row';
          row.innerHTML = `
            <span class="manifest-comp-name">${componentName}</span>
            <div class="manifest-meta-group">
              <span class="manifest-material-tag">${compState.material}</span>
              <span class="manifest-price-tag">${formatMoney(variant.price)}</span>
            </div>
          `;
          manifestList.appendChild(row);
          selections.push(variant);
        }
      }

      if (isCompleteKit) {
        document.getElementById('sds-selections-count').textContent = 'ALL COMPONENTS';
      } else {
        document.getElementById('sds-selections-count').textContent = `${checkedCount} OF ${totalCount} PANELS`;
      }

      // Calculate dynamic discount if Scenario B (all components checked)
      if (isCompleteKit) {
        const discountPercent = config.discountPercent || 10;
        discountAmount = Math.round(retailSubtotal * (discountPercent / 100));
        finalPrice = retailSubtotal - discountAmount;

      }
    }

    // Fallback: if finalPrice was never set (partial/incomplete selection), use retailSubtotal
    if (finalPrice === 0) finalPrice = retailSubtotal;

    // Update UI Summary Elements
    document.getElementById('sds-review-subtotal').textContent = formatMoney(retailSubtotal);

    const kitSaveRow = document.getElementById('sds-kit-save-row');
    const kitTotalRow = document.getElementById('sds-kit-total-row');

    if (discountAmount > 0) {
      if (kitSaveRow) {
        kitSaveRow.classList.remove('hidden');
        document.getElementById('sds-review-discount').textContent = `-${formatMoney(discountAmount)}`;

        const discountPercent = isCompleteKit ? (config.discountPercent || 10) : Math.round((discountAmount / retailSubtotal) * 100);
        const discountLabel = kitSaveRow.querySelector('.summary-label');
        if (discountLabel) {
          discountLabel.innerHTML = `
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: middle; margin-right: 4px;">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
            KIT SAVE (-${discountPercent}%)
          `;
        }
      }
      if (kitTotalRow) {
        kitTotalRow.classList.remove('hidden');
        document.getElementById('sds-review-total').textContent = formatMoney(finalPrice);
      }
    } else {
      // No discount: hide KIT SAVE row but always show TOTAL CONFIGURED SPEC with full price
      if (kitSaveRow) kitSaveRow.classList.add('hidden');
      if (kitTotalRow) {
        kitTotalRow.classList.remove('hidden');
        const totalEl = document.getElementById('sds-review-total');
        if (totalEl) totalEl.textContent = formatMoney(finalPrice);
      }
    }

    const configuredPriceValue = document.querySelector('.sds-configured-price .price-item--regular, .sds-configured-price .price-item--sale');
    if (configuredPriceValue) {
      configuredPriceValue.textContent = formatMoney(finalPrice);
    }

    // Update hidden form inputs
    updateHiddenInputs(selections);
  }

  // Populate hidden form inputs dynamically for submission
  function updateHiddenInputs(selections) {
    const container = document.getElementById('configurator-hidden-inputs');
    if (!container) return;

    container.innerHTML = '';

    const qtyInput = document.querySelector('.quantity__input') || { value: 1 };
    const quantity = parseInt(qtyInput.value) || 1;

    const componentValues = Object.values(state.components);
    const isCompleteKit = componentValues.length >= 2 && componentValues.every(c => c.checked);
    const allSameMaterial = Object.values(state.components).every(c => c.material === Object.values(state.components)[0].material);

    const form = document.querySelector(`form[id^="product-form-"]`);
    // Find input by class or name to be robust
    const defaultIdInput = form ? (form.querySelector('.product-variant-id') || form.querySelector('input[name="id"]')) : null;

    let isScenarioA = false;
    let kitVariant = null;

    if (componentValues.length === 1) {
      // Single-component product is always Scenario A
      const compName = Object.keys(state.components)[0];
      const compMaterial = Object.values(state.components)[0].material;
      kitVariant = findVariant(compName, compMaterial);
      if (kitVariant) {
        isScenarioA = true;
      }
    } else if (isCompleteKit && allSameMaterial) {
      // Multi-component kit with all items checked of same material
      const kitMaterial = Object.values(state.components)[0].material;
      kitVariant = findVariant(config.completeKitValue, kitMaterial);
      if (kitVariant) {
        isScenarioA = true;
      }
    }

    if (isScenarioA) {
      if (defaultIdInput) {
        defaultIdInput.value = kitVariant.id;
        defaultIdInput.disabled = false;
        defaultIdInput.setAttribute('name', 'id');
        defaultIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const inputId = document.createElement('input');
        inputId.type = 'hidden';
        inputId.name = 'id';
        inputId.value = kitVariant.id;
        container.appendChild(inputId);
      }
    } else {
      // Disable default input so Shopify ignores it and uses our items[...] array!
      if (defaultIdInput) {
        defaultIdInput.disabled = true;
        defaultIdInput.removeAttribute('name');
        defaultIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Add individual checked variants
      selections.forEach((variant, index) => {
        const inputId = document.createElement('input');
        inputId.type = 'hidden';
        inputId.name = `items[${index}][id]`;
        inputId.value = variant.id;
        container.appendChild(inputId);

        const inputQty = document.createElement('input');
        inputQty.type = 'hidden';
        inputQty.name = `items[${index}][quantity]`;
        inputQty.value = quantity;
        container.appendChild(inputQty);
      });
    }

    // Update Add to Cart / Submit Button State
    const submitButton = form ? form.querySelector('[type="submit"]') : null;
    const submitButtonText = submitButton ? submitButton.querySelector('span') : null;

    if (submitButton) {
      let canAdd = true;
      let buttonText = config.primaryBtnText || 'ADD BUILD TO CART';

      if (isScenarioA) {
        if (!kitVariant) {
          canAdd = false;
          buttonText = 'UNAVAILABLE';
        }
      } else {
        const checkedComponents = Object.entries(state.components).filter(([_, c]) => c.checked);
        if (checkedComponents.length === 0) {
          canAdd = false;
          buttonText = 'SELECT COMPONENTS';
        } else {
          // Check if any checked component is unavailable (does not exist in variants)
          for (const [componentName, compState] of checkedComponents) {
            const variant = findVariant(componentName, compState.material);
            if (!variant) {
              canAdd = false;
              buttonText = 'UNAVAILABLE';
              break;
            }
          }
        }
      }

      if (canAdd) {
        submitButton.removeAttribute('disabled');
        submitButton.removeAttribute('aria-disabled');
        submitButton.classList.remove('disabled');
        if (submitButtonText) {
          submitButtonText.textContent = buttonText;
        }
      } else {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('disabled');
        if (submitButtonText) {
          submitButtonText.textContent = buttonText;
        }
      }
    }

    // Toggle visibility of dynamic checkout buttons (e.g. PayPal) since Shopify only supports them for single-variant checkout (Scenario A)
    const paymentButton = form ? form.querySelector('.shopify-payment-button') : null;
    if (paymentButton) {
      if (isScenarioA && canAdd) {
        paymentButton.style.setProperty('display', '', 'important');
      } else {
        paymentButton.style.setProperty('display', 'none', 'important');
      }
    }
  }

  // Event Listeners for Complete Kit Card
  if (compCompleteKitCheckbox) {
    compCompleteKitCheckbox.addEventListener('change', (e) => {
      state.completeKitChecked = e.target.checked;
      if (state.completeKitChecked) {
        syncComponentsToKit();
      } else {
        // If unchecking the complete kit, uncheck all individual components
        for (const componentName of Object.keys(state.components)) {
          state.components[componentName].checked = false;
          const card = document.querySelector(`.configurator-card[data-component="${componentName}"]`);
          if (card) {
            const cb = card.querySelector('.configurator-checkbox');
            if (cb) cb.checked = false;
          }
        }
      }
      updateConfigurator();
    });
  }

  // Event Listeners for Card Toggles
  document.querySelectorAll('.configurator-card').forEach(card => {
    const componentName = card.dataset.component;
    const isKit = card.classList.contains('complete-kit-card');
    const availableMaterials = getAvailableMaterialsForComponent(componentName);

    // Checkbox Toggle
    const checkbox = card.querySelector('.configurator-checkbox');
    if (checkbox && !isKit) {
      checkbox.addEventListener('change', (e) => {
        state.components[componentName].checked = e.target.checked;
        checkCompleteKitStatus();
        updateConfigurator();
      });
    }

    // Material Pills Toggle (FRP vs CARBON)
    card.querySelectorAll('.material-pill').forEach(pill => {
      pill.addEventListener('click', (e) => {
        card.querySelectorAll('.material-pill').forEach(p => p.classList.remove('active'));
        e.target.classList.add('active');

        const group = e.target.dataset.materialGroup;
        const subFinishSelector = card.querySelector('.sub-finish-selector');
        let finishVal = 'Fiberglass (FRP)';

        if (group === 'FRP') {
          if (subFinishSelector) subFinishSelector.classList.add('hidden');
          finishVal = availableMaterials.find(m => m.toLowerCase().includes('frp') || m.toLowerCase().includes('fiberglass')) || 'Fiberglass (FRP)';
        } else {
          const hasDetailedCarbon = hasDetailedSubFinishesGlobal();
          if (hasDetailedCarbon) {
            if (subFinishSelector) subFinishSelector.classList.remove('hidden');
            const activeSubBox = card.querySelector('.sub-finish-box.active');
            finishVal = activeSubBox ? activeSubBox.dataset.finish : 'Matte Carbon';
          } else {
            if (subFinishSelector) subFinishSelector.classList.add('hidden');
            finishVal = availableMaterials.find(m => m.toLowerCase().includes('carbon') || m.toLowerCase().includes('kevlar')) || 'Carbon Fiber';
          }
        }

        if (isKit) {
          state.completeKitMaterial = finishVal;
          syncComponentsToKit();
        } else {
          state.components[componentName].material = finishVal;
          checkCompleteKitStatus();
        }
        updateConfigurator();
      });
    });

    // Carbon Finish Boxes Toggle (Matte, Gloss, Forged, Kevlar)
    card.querySelectorAll('.sub-finish-box').forEach(box => {
      box.addEventListener('click', (e) => {
        const targetBox = e.target.closest('.sub-finish-box');
        card.querySelectorAll('.sub-finish-box').forEach(b => b.classList.remove('active'));
        targetBox.classList.add('active');

        const finishVal = targetBox.dataset.finish;
        if (isKit) {
          state.completeKitMaterial = finishVal;
          syncComponentsToKit();
        } else {
          state.components[componentName].material = finishVal;
          checkCompleteKitStatus();
        }
        updateConfigurator();
      });
    });
  });

  // Listen to Quantity input changes to update inputs
  const quantityInput = document.querySelector('.quantity__input');
  if (quantityInput) {
    quantityInput.addEventListener('change', () => {
      updateConfigurator();
    });
  }

  // Intercept Shopify form submit to ensure inputs are fresh
  const form = document.querySelector(`form[id^="product-form-"]`);
  if (form) {
    form.addEventListener('submit', (e) => {
      updateConfigurator();

      const componentValues = Object.values(state.components);
      const isCompleteKit = componentValues.length >= 2 && componentValues.every(c => c.checked);
      const allSameMaterial = Object.values(state.components).every(c => c.material === Object.values(state.components)[0].material);

      let isScenarioA = false;
      if (componentValues.length === 1) {
        // Single-component product is always Scenario A
        const compName = Object.keys(state.components)[0];
        const compMaterial = Object.values(state.components)[0].material;
        const kitVariant = findVariant(compName, compMaterial);
        if (kitVariant) {
          isScenarioA = true;
        }
      } else if (isCompleteKit && allSameMaterial) {
        const kitMaterial = Object.values(state.components)[0].material;
        const kitVariant = findVariant(config.completeKitValue, kitMaterial);
        if (kitVariant) {
          isScenarioA = true;
        }
      }

      if (!isScenarioA) {
        // Intercept and handle multi-item AJAX submit
        e.preventDefault();
        e.stopImmediatePropagation();

        const qtyInput = document.querySelector('.quantity__input') || { value: 1 };
        const quantity = parseInt(qtyInput.value) || 1;

        const bundleId = 'bundle-' + Date.now() + '-' + Math.floor(Math.random() * 1000);
        const expectedCount = Object.keys(state.components).length;

        const items = [];
        for (const [componentName, compState] of Object.entries(state.components)) {
          if (compState.checked) {
            const variant = findVariant(componentName, compState.material);
            if (variant) {
              items.push({
                id: parseInt(variant.id),
                quantity: quantity,
                properties: {
                  '_bundle_id': bundleId,
                  '_bundle_expected_count': expectedCount,
                  '_bundle_type': 'Mixed Material Kit'
                }
              });
            }
          }
        }

        if (items.length === 0) return;

        // Show loading state on button
        const submitButton = form.querySelector('[type="submit"]');
        const submitButtonText = submitButton ? submitButton.querySelector('span') : null;
        if (submitButton) {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
          const spinner = submitButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const sectionsToRender = cart ? cart.getSectionsToRender().map(s => s.id) : [];

        // Send JSON request to cart add
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: items,
            sections: sectionsToRender,
            sections_url: window.location.pathname
          })
        })
          .then(response => response.json())
          .then(cartData => {
            if (cartData.status) {
              // Reset loading state immediately on error
              if (submitButton) {
                submitButton.removeAttribute('aria-disabled');
                submitButton.classList.remove('loading');
                const spinner = submitButton.querySelector('.loading__spinner');
                if (spinner) spinner.classList.add('hidden');
              }
              console.error('[CONFIGURATOR] Shopify error response:', cartData.description);
              const errorMessage = form.querySelector('.product-form__error-message');
              if (errorMessage) {
                errorMessage.textContent = cartData.description;
                errorMessage.parentElement.removeAttribute('hidden');
              }
              return cartData;
            }

            // Apply discount code asynchronously if Scenario B (all components checked)
            if (isCompleteKit) {
              const discountCode = config.discountCode || 'COMPLETEKIT10';
              try {
                sessionStorage.setItem('sds_bundle_discount_applied', 'true');
              } catch (e) { }
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ discount: discountCode })
              })
                .then(() => cartData) // Return the original cartData to pass downstream
                .catch(err => {
                  console.error('[CONFIGURATOR] Discount API error during submit:', err);
                  return cartData;
                });
            }
            return cartData;
          })
          .then(cartData => {
            if (!cartData || cartData.status) return;

            // Reset loading state
            if (submitButton) {
              submitButton.removeAttribute('aria-disabled');
              submitButton.classList.remove('loading');
              const spinner = submitButton.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');
            }

            // Trigger cart drawer/notification update
            if (cart) {
              cart.renderContents(cartData);
            } else {
              showCartNotification("BUILD ADDED TO CART", "Your customized specification has been added to the order slip.");
              updateHeaderCartCount();
            }
          })
          .catch(err => {
            console.error('[CONFIGURATOR] Network/API Error:', err);
            showCartNotification("ADD TO CART FAILED", "We encountered an issue adding the items. Please try again.");
          });
      }
    }, true); // Use capture phase to intercept before Dawn's default handler!
  }

  // Initial Run
  if (state.completeKitChecked) {
    syncComponentsToKit();
  }
  updateConfigurator();
}

document.addEventListener('DOMContentLoaded', initProductConfigurator);

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#configurator-variants-data')) {
    initProductConfigurator();
  }
});
